import React from 'react';
import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

import Button from '../../../Core/Button';
import Link from '../../../Core/Link';

const color_white = '#FFF';
const color_skyblue = '#A9E6F5';
const font_content = `
  font-family: ${themeGet('fonts.sans')};
  font-size: 20px;
  line-height: 27px;
`;

export const MiniBanner = styled.div`
  align-items: center;
  background-color: ${themeGet('colors.maroon')};
  display: flex;
  flex-direction: column;
  padding: 21px 23px 17px 24px;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    flex-direction: row;
    height: 90px;
    justify-content: center;
    padding-left: 0;
    padding-right: 0;
  }
`;

export const Content = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 21px;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin-bottom: 0;
  }
`;

export const Icon = styled.div`
  padding-left: 18px;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding-left: 0;
  }
`;

export const Description = styled.p`
  ${font_content};
  color: ${color_white};
  font-weight: 400;
  padding-left: 25px;
  padding-right: 9px;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding-left: 30px;
    padding-right: 0;
  }
`;

export const Highlight = styled.span`
  ${font_content};
  color: ${color_skyblue};
  font-weight: 700;
`;

export const StyledLink = styled(props => <Link {...props } />)`
  border-bottom: 0;

  &:hover {
    border-bottom: 0;
  }
`;

export const StyledButtonLink = styled(props => <Button { ...props } />)`
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin-left: 31px;
    width: 217px;
  }
`;
